import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initSupabase } from "@/lib/supabase";

// Silence ONLY the benign "ResizeObserver loop…" browser notice. It is a no-op warning
// (not a real error) that the CRA dev overlay otherwise shows full-screen. Scoped strictly
// to that exact message — all other errors surface normally.
const _isResizeObserverNoise = (msg) =>
  typeof msg === "string" &&
  (msg.includes("ResizeObserver loop completed with undelivered notifications") ||
    msg.includes("ResizeObserver loop limit exceeded"));
window.addEventListener("error", (e) => {
  if (_isResizeObserverNoise(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
initSupabase().then((configError) => root.render(configError ? (
  <div data-testid="config-error" style={{ padding: 32, fontFamily: "sans-serif" }}>
    <h1>Configuration error</h1><p>{configError}</p><p>The app has been stopped to protect data. Contact your administrator.</p>
  </div>
) : (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
)));
